	export const getCurrentTimestamp = () => {
		const now = new Date();
		const year = now.getFullYear();
		const month = String(now.getMonth() + 1).padStart(2, '0'); // 월 (0부터 시작하므로 +1)
		const day = String(now.getDate()).padStart(2, '0'); // 일
		const hours = String(now.getHours()).padStart(2, '0'); // 시간
		const minutes = String(now.getMinutes()).padStart(2, '0'); // 분
		return `${year}-${month}-${day} ${hours}:${minutes}`;
	};
	
	export const formatDate = (excelSerial: number, type: string) => {
    const excelEpoch = new Date(Date.UTC(1899, 11, 30));
    const millisecondsPerDay = 86400000;
    const date = new Date(excelEpoch.getTime() + excelSerial * millisecondsPerDay);

    const year = date.getUTCFullYear();
    const month = type === "inspection_detail" ? date.getUTCMonth() + 1 : String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = type === "inspection_detail" ? date.getUTCDate() : String(date.getUTCDate()).padStart(2, '0');

    const hours = String(Math.floor((excelSerial % 1) * 24)).padStart(2, '0');
    const minutes = String(Math.round(((excelSerial % 1) * 24 * 60) % 60)).padStart(2, '0');

    return type !== "create"
        ? `${year}-${month}-${day} ${hours}:${minutes}`
        : `${year}-${month}-${day}`;
};
